import { Button } from 'antd';
import PageLoader from 'components/Shared/PageLoader';
import PrintTemplate from 'components/Shared/PrintTicket/PrintTemplate';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { Helmet } from 'react-helmet';
import printTicketsService from 'services/printServices';
import { printTicketsData } from 'services/printServices/types';
import ticketService from 'services/ticket';

const PrintSelectedTicketsPage = () => {
  const [loading, setLoading] = useState(true);
  const [printTicketsData, setPrintTicketsData] = useState<printTicketsData>(null);

  const attendancePrinted = (eventId: string, attendanceIds: string[]) => {
    ticketService.attendancePrinted(eventId, attendanceIds).subscribe();
  };

  useEffect(() => {
    printTicketsService.getPrintTicketsData().subscribe({
      next: printTicketsData => {
        printTicketsData.eventImage = process.env.REACT_APP_CDN_URL + printTicketsData.eventImage;
        setPrintTicketsData(printTicketsData);
        setLoading(false);
      },
    });
  }, []);

  if (loading) {
    return <PageLoader />;
  }

  return (
    <>
      <Helmet>
        <title>Blinket | {printTicketsData.event.title}</title>
        <meta property='og:image' content={printTicketsData.eventImage} />
        <meta property='og:title' content={printTicketsData.event.title} />
      </Helmet>
      <div style={{ backgroundColor: '#FFFFFF' }}>
        <div className='noprint'>
          <Button
            className='noprint'
            style={{ margin: '20px 39px 18px 39px' }}
            onClick={() => {
              try {
                attendancePrinted(
                  printTicketsData.event.id,
                  printTicketsData.data.map(item => {
                    return item.attendance_id;
                  }),
                );
                document.execCommand('print', false, null);
              } catch {
                window.print();
              }
            }}
            type='primary'
          >
            {isMobile ? 'Baixar' : 'Imprimir'}
          </Button>
        </div>
        <div
          style={{
            paddingLeft: 10,
            backgroundColor: '#FFFFFF',
          }}
          id='tickets-to-print'
        >
          <div
            style={{
              paddingLeft: 30,
              backgroundColor: '#FFFFFF',
            }}
          >
            <PrintTemplate
              data={printTicketsData.data}
              event={printTicketsData.event}
              eventImage={printTicketsData.eventImage}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default PrintSelectedTicketsPage;
